/**
*
* Disclaimer: Source code mentioned below is(are) Intellectual Property of
* Crayon Data Holdings Limited (including its subsidiaries and affiliates).
* Crayon Data Holdings Limited reserves right to own and control it the way
* it may deem fit. You must refrain from use, access, read, modify, add or
* delete, sell or use in any other package or programme pertaining to such
* source code without explicit prior written approval of
* Crayon Data Holding Limited. Breach of the same shall attract penalty as
* applicable.
*
*/

import React, { PureComponent } from "react";
import clsx from "clsx";

import Icon from "../Icons";
import Button from "../Button";
import DemoModal from "../Redeem";
import { interaction, getError } from "../../service";
import MerchantInfo from "../Merchant_Info";
import { formatDateDDMMMYYYY, formatDateArabicDDMYYYY ,formatDateProfileMonth } from "../../pages/helper";
import { offerItemHeader } from "../../constants";
import uiConfig from "../../uiConfig";
import RedeemOfferCard from "../Redeem_Offer_Card";
import {arabicContent} from "../../constants/index";
import config from "../../service/config";
import MapComponent from "../GoogleMapStore";
const lang = localStorage.getItem("language");

//Import Config
var MatomoTracker = require('matomo-tracker');
var matomo = new MatomoTracker(config.siteId, config.siteURL);

export default class BestOffer extends PureComponent {
  state = {
    isVisibleOfferInfo: false,
    activeMenu: "offerDetails",
    isModalOpen: false,
    width: 0,
    claimStatus : this.props.item.claimed,
    isExpand: false,
    viewStores: false
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    if(localStorage.getItem("openClaimModal") && localStorage.getItem("openClaimModal") === "true"){
      this.setState({isModalOpen: true});
    }
  }
  
  viewStores = () => {
    this.setState({
      viewStores : true
    })
  }
  googleMap = (item) => {
    window.open("https://maps.google.com?q="+item?.geoCode?.latitude+","+item?.geoCode?.longitude );
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  /* OnClick Function */
  _onChangeTab = (id) => {
    this.setState({ activeMenu: id });
  };

  _onClose = () => {
    localStorage.setItem("openClaimModal","false")
    localStorage.removeItem("offerDetail")
    localStorage.removeItem("merchantDetail")
    this.setState({ isModalOpen: false });
    document.documentElement.style.overflowY='auto'
    document.body.style.overflowY = 'auto';
  };

  _onClick = (itemId) => {
    const { item,merchantId } = this.props;
    const { claimStatus } = this.state;
    if (localStorage.getItem("USERID")===null) {
      this.props._openLogin();
      localStorage.setItem("interactionType","CLAIM");
      localStorage.setItem("interactionId",itemId);
      localStorage.setItem("interactionFrom","Merchant");
      localStorage.setItem("offerDetail", JSON.stringify(this.props.item))
      localStorage.setItem("merchantDetail",JSON.stringify({
        "merchantName":this.props.merchantName,
        "merchantItem":this.props.merchantItem,
        "baseURL":this.props.baseURL
      }))
    }
    if (localStorage.getItem("USERID")) {
      this.setState({ isModalOpen: true });
      document.documentElement.style.overflowY='hidden'
      document.body.style.overflowY = 'hidden';

      if(!claimStatus){
        this.setState({ claimStatus : !claimStatus });
        matomo.track({
          url: window?.location?.href,
          e_c: merchantId,
          e_a: 'CLAIM',
          e_n: item.id,
        });
        interaction("CLAIM", "OFFER",itemId)
          .then((res) => {
            // this.setState({ claimStatus : !claimStatus });
        //    this.setState({ isModalOpen: true });
          })
          .catch((err) => {
            if (err && err.data&&err.data.status === 404) {
            } else {
          //    console.log(getError(err));
            }
          });
        }
    }
  
  };

  onRedeemInteraction =()=>{
    const { item, merchantId } = this.props;
    interaction("REDIRECT", "OFFER",item.id)
        .then((res) => {
        })
        .catch((err) => {
          if (err && err.data&&err.data.status === 404) {
          } else {
          //  console.log(getError(err));
          }
        });
        matomo.track({
          url: window?.location?.href,
          e_c: merchantId,
          e_a: 'REDEEM',
          e_n: item.id
        });
        matomo.track({
          url: window?.location?.href,
          e_c: item?.url,
          e_a: 'REDIRECT_MERCHANT',
          e_n: merchantId
        });
  }

  _onClickItem = () => {
    const { isVisibleOfferInfo } = this.state;
    this.setState({ isVisibleOfferInfo: !isVisibleOfferInfo });
  };

  toggleExpandCard =() =>{
    this.setState({isExpand:true})
  }  

  /* Other Render Functions */
  _renderTitle(title, id) {
    const { activeMenu } = this.state;
    const cls = {
      nav: true,
      "nav-act": id === activeMenu
    };

    return (
      <div className={`${clsx(cls)} p-0 ${lang === 'AR' ? "nav-ar" : ""}`}  onClick={() => this._onChangeTab(id)}
      style={(config.clientName === "HDFC") ?id===activeMenu?{marginRight:"32px",fontWeight:"bold",color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenuActive.color,borderBottom:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenuActive.borderBottom}:{marginRight:"32px",color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenu.color} : 
          id===activeMenu?{fontWeight:"bold",color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenuActive.color,borderBottom:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenuActive.borderBottom}:{color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardMenu.color}}
      >
        {(title)?title.toUpperCase():''}
      </div>
    );
  }


  /* Other Render Functions */
  _renderMobileView(mer) {
    const { isVisibleOfferInfo, claimStatus,activeMenu } = this.state;
    const { item, itemUrl,isActiveOffer,from } = this.props;
    let claimedTxt = lang === "AR" ? arabicContent.claimed : "Offer Availed";
    let claimTxt = lang === "AR" ? arabicContent.claim : "Claim now";
    let onlineTxt = lang === "AR" ? arabicContent.online : "Online Offer";
    let instoreTxt = lang === "AR" ? arabicContent.instore : "Instore";
    const minWidth = 768;


    if (minWidth >= this.state.width) {
      return (
        <div className="col-md-12 p-0 best_offer">
          <div className="col-md-12 p-0  _ai-c">
            <div className={`col-md-2 p-0`}>
              {/* {item.image && <Image src={item.image.replace(/ /g, "%20")} w={60} h={60} />} */}
              {/* <Image src={item.image.replace(/ /g, "%20")} w={60} h={60} /> */}
            </div>
            <div className="col-md-10 p-0">
              <div className="heading-best-offer mbl" style={{color:uiConfig.config?.whitelabel?.merchant_details?.offer_cards.offerCardTitleColor}}>
                <span className="offer-desc mbl">{item.name}</span>
                <span className={`toggle flex-center ${lang === 'AR' ? "mr-8" : "ml-8"}`} onClick={this._onClickItem}>
                <Icon
              fill="#000"
              width={14}
              height={14}
              name={isVisibleOfferInfo ? "arrowUp" : "arrowDown"}
            />
          </span>
              </div>
              
              {/* <div className="desc-best-offer mbl">
                Online Exclusive - New lines added daily
              </div> */}
            </div>
          </div>
          <div className={isVisibleOfferInfo?"card-show":"card-hide"}>
          <div className={`p-0 header-item ${lang === 'AR' ? "col-md-12" : "col-md-9"}`}>             
            <div style={{marginBottom: '10px', borderBottom: '1px solid #ececec'}}>
            {this._renderTitle(lang === 'AR' ? arabicContent.offerDetails : offerItemHeader.offerDetails, "offerDetails")}
            {this._renderTitle(lang === 'AR' ? arabicContent.redeem : offerItemHeader.redeem, "redeem")}
            {config.storeLocationKey && (item.isOnline!==true || item?.applicableChannel?.includes('online','offline')) && this._renderTitle(
              "Stores Location",
              "storeLocation"
            )}
            {this._renderTitle(
              lang === 'AR' ? arabicContent.termsAndCondition : 'T & C',
              "termsAndCondition"
            )}
            {item.location
            &&this._renderTitle(
              lang === 'AR' ? arabicContent.merchantAndStores : offerItemHeader.merchantAndStores,
              "merchantAndStores"
            )}
            </div>
          </div> 
          {activeMenu!=="merchantAndStores"?  
          <div className={`col-md-12 p-0 item-det-info ${lang === 'AR' ? "item-det-info-ar" : ""}`}>
            {this._renderDescription()}
            {this._renderRedeem()}
            {this._renderTermsAndCondition()}
            {config.storeLocationKey && (item.isOnline!==true || item?.applicableChannel?.includes('online','offline')) && this._renderStoreLocation(mer)}
          </div>:item.location&&
          <div> <MerchantInfo item={item} /></div>
        }
        </div>
        <div className={"col-md-12 p-0 mt-10 _ai_baseline"}>
        {this.props.itemType!=="PORTFOLIO_OFFERS" &&
            <div className="flex-start">
              <div className="info-offer flex-center mbl" style={{ color: uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardInfoColor }}>
                {lang === "AR" ? formatDateArabicDDMYYYY(item.validTo) : formatDateDDMMMYYYY(item.validTo)} |{" "}
                {item.isOnline ? onlineTxt : instoreTxt}
              </div>
            </div>
    }
                {this.props.itemType==="PORTFOLIO_OFFERS" &&
          <div className="flex-start">
          <div className="infooff flex-center">
         <span style={{ fontWeight:400 }}>This offer is valid until</span>&nbsp;
         <span style={{ color: uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardInfoColor,fontWeight:700 }}>{formatDateProfileMonth(item.validTo)}</span>
         </div>
         </div>

 }
            {
              !item?.isExpired && from !=="expired" && this.props.itemType!=="PORTFOLIO_OFFERS" &&
                <div className="flex-end btn-div">
                  <Button
                    variant={claimStatus ? "success" : "primary"}
                    size="md"
                    label={claimStatus ? claimedTxt : claimTxt}
                    onClick={() => this._onClick(item.id)}
                  />
                </div>
    }
                 {  item?.isExpired || from === "expired" &&
                <div className="expire-div flex">
                  <div>Oops!</div>
                  <div className="oops-div" ></div>
                  <div>This offer has expired.
                    Do check out other exciting offers!</div>
                </div>
            }
          </div>
        </div>
      );
    }

    return null;
  }

  _renderNormalView(mer) {
    const { claimStatus,activeMenu } = this.state;
    const { item,isActiveOffer, itemUrl, from} = this.props;
  
    const minWidth = 768;
    let {isExpand} = this.state;
   // console.log(this.props)
    if (minWidth < this.state.width) {
      return (
        <div>
        <div className={`col-md-12 p-0 ${lang === 'AR' ? "flex" : ""}`}>
         
         <div className={`col-md-9`}>
            <div className={`p-100 ${lang === 'AR' ? "p-100-ar" : ""}`}>
            <div className="best-offer-header" style={{color:uiConfig.config?.whitelabel?.merchant_details?.offer_cards.offerCardTitleColor}}>{item.name}</div>

            {<div className="info-offer" style={{color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardInfoColor}}>
            {lang === 'AR' ? arabicContent.offerInfo1 : 
            <span>To know more about the offer, click on "Expand for details". For redeeming this offer, click on "Claim now" button.
            <br/>Click on "Offer details" to know more about the offer, it's validity and usage.
             <br/>Click on “How to redeem” to know about activation and redemption of the same.</span>}
            </div>}
            </div>
            {/* {config.clientName === "HDFC" && itemUrl&&<div className="info-offer" style={{color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardInfoColor}}>
                {lang === 'AR' ? arabicContent.offerInfo1 : `This offer is available to ${config.clientName} Cards. To redeem this offer, visit `}
                <span style={{color:uiConfig.config.whitelabel.urlColor}} className="redeem-url ellipsis" onClick={()=> {this.props.onClick()}}>{itemUrl}</span> {!item.redemptionCode ? <span></span> : <span>
                {lang === 'AR' ? arabicContent.offerInfo2 : `, please enter promo code while at checkout`}</span>} 
            </div>} */}
            {!isExpand &&<div className="text-expand" style={{ color: !item?.isExpired && from !== "expired" ? "#005AB7" : "#E30613" }} onClick={()=>this.toggleExpandCard()} >
              {lang === 'AR' ? arabicContent.expandTxt : `Expand for Details`}
            </div>}
            <div className={isExpand?"card-show":"card-hide"}>
            <div className={`p-0 header-item ${lang === 'AR' ? "col-md-12" : "col-md-9"}`}>
            {this._renderTitle(lang === 'AR' ? arabicContent.offerDetails : offerItemHeader.offerDetails, "offerDetails")}
            {this._renderTitle(lang === 'AR' ? arabicContent.redeem : offerItemHeader.redeem, "redeem")}
            {config.storeLocationKey && (item.isOnline!==true || item?.applicableChannel?.includes('online','offline')) && this._renderTitle(
              "Store Locations",
              "storeLocation"
            )}
            {this._renderTitle(
              lang === 'AR' ? arabicContent.termsAndCondition : offerItemHeader.termsAndCondition,
              "termsAndCondition"
            )}
            {item.location
            &&this._renderTitle(
              lang === 'AR' ? arabicContent.merchantAndStores : offerItemHeader.merchantAndStores,
              "merchantAndStores"
            )}
          </div>
        </div>
          </div>
          <div className="col-md-3 p-0">
          <RedeemOfferCard itemUrl={itemUrl} item={item} claimStatus={claimStatus} _onClick={this._onClick} from={from}
            itemType={this.props.itemType}
              />
            </div>
          </div>
          <div >
          {activeMenu!=="merchantAndStores" && this.state.isExpand ?
          
          <div>
            <div  style={{color:uiConfig.config.whitelabel.merchant_details.offer_cards.offerCardDescriptionTextColor}} 
          className={`col-md-12 item-det-info ${lang === 'AR' ? "" : ""}`}>
            {this._renderDescription()}
            {this._renderRedeem()}
            {this._renderTermsAndCondition()}
            {config.storeLocationKey && (item.isOnline!==true || item?.applicableChannel?.includes('online','offline')) && this._renderStoreLocation(mer)}
            </div>
          </div> 
          :item.location
          &&
          <div> <MerchantInfo item={item} /></div>
        }
       </div>
       </div>
      );
    }

    return null;
  }

  _renderDescription() {
    const { item } = this.props;
    const { activeMenu } = this.state;

    if (activeMenu !== "offerDetails") {
      return null;
    } else {
      return (
        <div dangerouslySetInnerHTML={{ __html: item.description }} />
      );
    }

    // if (lang === "AR"){
    //   return arabicContent.description;
    // }
    

  }

  _renderMerchantAndStores() {
    const { item } = this.props;
    const { activeMenu } = this.state;

    if (activeMenu !== "offerDetails") return null;

    return <MerchantInfo item={item} />
  }

  _renderRedeem() {
    const { item } = this.props;
    const { activeMenu } = this.state;
    if (activeMenu !== "redeem") {
      return null;
    } else {
      return (
        <div dangerouslySetInnerHTML={{ __html: item.howToRedeem }} />
      );
    }

    // if (lang === "AR"){
    //   return arabicContent.howToRedeem;
    // }
  }

  _renderTermsAndCondition() {
    const { item } = this.props;
    const { activeMenu } = this.state;

    if (activeMenu !== "termsAndCondition") {
      return null;
    } else {
      return (
        <div dangerouslySetInnerHTML={{ __html: item.termsAndConditions }} />
      );
    }

    //if (activeMenu !== "termsAndCondition") return null;

    // if (lang === "AR"){
    //   return arabicContent.termsAndConditions;
    // }

    //return item.termsAndConditions;
  }
  _renderAddress(data) {
    const minWidth = 768;
    // let cm=0
    // for (let i = 0; i < data.address.length; i++) {
    //   if (data.address[i] === ",") {
    //     cm=i
    //     break; 
    //   }
    // }
    return (
      <>
      <div className="locHead flex flex-between">
        {/* <div>
        {data.address.slice(0,cm)}
        </div> */}
        <div className="locAdd">
        {data?.address && data.address!==undefined? data.address:"Visit/ Contact the nearest merchant store."}
        </div>
        {data?.address && data.address!==undefined && data.geoCode.latitude!==null && data.geoCode.latitude!=="" &&
        <div className={`viewMap`} onClick={()=> this.googleMap(data)}>
        VIEW ON MAP
        </div> 
        }
      </div>
       {/* <div className="locAdd">
        {data.address.slice(cm+1,data.length)}
       </div> */}
      </>
    )
  }
  _renderStoreLocation(mer) {
    const { item } = this.props;
    const { activeMenu } = this.state;
    const minWidth = 768;
    let a = 0;
    let g = 0;
    if (this.props.item?.locations !==undefined && this.props.item?.locations) {
      for (let k=0;k<this.props.item?.locations?.length;k++) {
        
        if (this.props.item?.locations[k]?.address) {
            a=a+1
        }
        if (this.props.item?.locations[k]?.geoCode.latitude!==null && this.props.item?.locations[k]?.geoCode.latitude!=="") {
            g=g+1
        }
      }
    }
    if (activeMenu !== "storeLocation") return null;
    return (
      <div className={`storeLocationList ${minWidth >= this.state.width ? "storeMob":""}`}>
      {a>0?
      <div className="col-md-6 p-0 locationscroll">
        <div style={{marginBottom:"23px"}}>
          Based on your location
        </div>
        {item?.locations?.map((add,idx)=> {
          if (idx<3) {
          return (
          <>
          <div className={`${minWidth < this.state.width && "locMar"} locAddress`}>
          {this._renderAddress(add)}
          </div>
          </>
          )}
        })}
        
        {item?.locations?.length>3 && item.isExpandedMenus === false ?
        <div className="viewStore" onClick={()=> this.viewStores()}>
        VIEW MORE STORES
        </div>
        :item?.locations?.length>3&&item?.locations?.map((add,idx)=> {
          if (idx>=3) {
          return (
          <>
          <div className={`${minWidth < this.state.width && "locMar"} locAddress`}>
          {this._renderAddress(add)}
          </div>
          </>
          )}
        })}
        
      </div>
            :
            <div className="col-12 locAdd">Visit/ Contact the nearest merchant store.</div>
            }
            <div className="col-md-6 p-0">
            {g>0 && a>0 &&
      <div className="map-view-des">
                {/* {loaderMap && (
                <div className="map-view-loader-des">
                  <div className="loader-map-des">
                    <svg class="circular-loader" viewBox="25 25 50 50">
                      <circle
                        className="loader-path"
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                      ></circle>
                    </svg>
                  </div>
                </div>
                )} */}
                <div className="map-des">
                  <MapComponent
                    homeList={item}
                    merchantItem={mer}
                    // handleChangeRadiusCenter={handleChangeRadiusCenter}
                    // getMapDetails={getMapDetails}
                    // handleClickMerchant={handleClickMerchant}
                    // markIDDesktop={markIDDesktop}
                    // focusCard={focusCard}
                  />
                </div>
                </div>
              }
              </div>
      </div>
    )
  }

  /* Render Functions */
  render() {
    var { isModalOpen,activeMenu } = this.state;
    const { item, baseURL ,merchantName,merchantItem } = this.props;
    const offerItem = localStorage.getItem("offerDetail")? JSON.parse(localStorage.getItem("offerDetail")):null
    const lmerchantName = localStorage.getItem("merchantDetail")? JSON.parse(localStorage.getItem("merchantDetail")).merchantName:null
    const lmerchantItem = localStorage.getItem("merchantDetail")? JSON.parse(localStorage.getItem("merchantDetail")).merchantItem:null
    const lbaseURL = localStorage.getItem("merchantDetail")? JSON.parse(localStorage.getItem("merchantDetail")).baseURL:null
  //  console.log(merchantName)
    return (
      <>
        {this._renderNormalView(lmerchantItem? lmerchantItem:merchantItem)}
        {this._renderMobileView(lmerchantItem? lmerchantItem:merchantItem)}
        
        {
          isModalOpen && 
          <DemoModal
            size="small"
            redeem={true}
            isModalOpen={isModalOpen}
            hide={this._onClose}
            item={offerItem? offerItem:item}
            baseURL={lbaseURL? lbaseURL:baseURL}
            onRedeemInteraction={this.onRedeemInteraction}
            merchantName={lmerchantName? lmerchantName:merchantName} 
            merchantItem={lmerchantItem? lmerchantItem:merchantItem} 
          />
        }
      </>
    );
  }
}
